import { render, staticRenderFns } from "./guide-mask.vue?vue&type=template&id=19938f7a&scoped=true"
import script from "./guide-mask.vue?vue&type=script&lang=js"
export * from "./guide-mask.vue?vue&type=script&lang=js"
import style0 from "./guide-mask.vue?vue&type=style&index=0&id=19938f7a&prod&lang=css"
import style1 from "./guide-mask.vue?vue&type=style&index=1&id=19938f7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19938f7a",
  null
  
)

export default component.exports